<page-load-header *ngIf="!initialized"></page-load-header>
<ng-container *ngIf="initialized">
  <div #fullScreen>
    <header>
      <!-- Fixed navbar -->
      <nav class="navbar nowrap navbar-expand-md navbar-light bg-white">
        <a class="navbar-brand text-truncate" [routerLink]="[]">{{ lobby.title }}</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <div class="form-inline ml-auto mt-2 mt-md-0">
            <button type="button" (click)="fullscreen()" class="btn btn-icon text-muted transition-3d-hover">
              <h3><span class="fas fa-compress-wide btn-icon__inner"></span></h3>
            </button>

            <button type="button" class="btn btn-icon" (click)="exitPage()">
              <h3 class="m-0 text-muted"><i class="fas fa-times"></i></h3>
            </button>
          </div>
        </div>
      </nav>
    </header>

    <main id="live-event" class="main-container">
      <div class="main-theater">
        <div class="row no-gutters">
          <div class="col text-center video-container">
            <div id="webRTCLayoutContainer" #webRTCLayoutContainer>&nbsp;</div>
          </div>
          <footer class="live-footer">
            <div class="row no-gutters">
              <div class="col pl-2 pr-2">
                <div class="d-flex">
                  <div class="mr-auto">
                    <div class="align-middle">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                          <button *ngIf="!publishing" type="button" (click)="activateCamera()" class="btn btn-xs btn-success transition-3d-hover"><i class="fas fa-video"></i> Join Video</button>
                          <button *ngIf="publishing" type="button" (click)="unpublish()" class="btn btn-xs btn-danger transition-3d-hover"><i class="fas fa-video-slash"></i> Leave Video</button>
                        </li>
                        <li *ngIf="publishing && !screenPublishing" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Share Screen">
                          <button type="button" (click)="shareScreen()" class="btn btn-xs btn-github transition-3d-hover"><i class="fas fa-laptop"></i> Share Screen</button>
                        </li>
                        <li *ngIf="screenPublishing" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Stop Sharing">
                          <button type="button" (click)="stopScreenSharing()" class="btn btn-xs btn-outline-warning transition-3d-hover"><i class="fas fa-laptop"></i> Stop Sharing</button>
                        </li>
                        <li *ngIf="publishing && publishingVideo" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                          <button type="button" (click)="toggleVideo()" class="btn btn-sm btn-icon btn-success transition-3d-hover">
                            <span class="fas fa-video"></span>
                          </button>
                        </li>
                        <li *ngIf="publishing && !publishingVideo" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                          <button type="button" (click)="toggleVideo()" class="btn btn-sm btn-icon btn-primary transition-3d-hover">
                            <span class="fas fa-video-slash"></span>
                          </button>
                        </li>

                        <li *ngIf="publishing && publishingAudio" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                          <button type="button" (click)="toggleAudio()" class="btn btn-sm btn-icon btn-success transition-3d-hover">
                            <span class="fas fa-microphone"></span>
                          </button>
                        </li>
                        <li *ngIf="publishing && !publishingAudio" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                          <button type="button" (click)="toggleAudio()" class="btn btn-sm btn-icon btn-primary transition-3d-hover">
                            <span class="fas fa-microphone-slash"></span>
                          </button>
                        </li>
                        <li class="list-inline-item device-settings-button" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                          <button (click)="showDeviceSettings()" type="button" class="btn btn-sm btn-icon btn-secondary transition-3d-hover">
                            <span class="fas fa-cog btn-icon__inner"></span>
                          </button>
                        </li>
                        <li class="list-inline-item mr-2 font-size-1" data-toggle="tooltip" data-placement="top" title="" data-original-title="Tech Support">
                          <p class="text-primary"><a class="cursor-pointer" type="button" (click)="techSupportClicked()">Help</a></p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="d-block d-xl-none">
                    <div class="align-middle">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item mr-3" data-toggle="tooltip" data-placement="top" title="" data-original-title="Chat">
                          <p class="text-primary"><a [ngClass]="{ 'live-event-link-active': showChat }" type="button" (click)="showChat = !showChat">Chat</a></p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="">
                    <div class="align-middle">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item mr-1" data-toggle="tooltip" data-placement="top" title="">
                          <p class="text-primary"><a [ngClass]="{ 'live-event-link-active': showVisitors }" type="button" (click)="showVisitors = !showVisitors; showAnalytics = false">People</a></p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="">
                    <div class="align-middle d-none d-md-block" style="line-height: 0; padding-top: 14px">
                      <ul class="list-inline mb-0">
                        <li *ngFor="let id of randomUserIds; let idx = index" class="list-inline-item mr-0" [ngClass]="{ 'ml-n3': idx > 0 }" data-toggle="tooltip" data-placement="top" title="" data-original-title="James Collins">
                          <div class="u-sm-avatar u-sm-avatar--bordered rounded-circle">
                            <img class="img-fluid rounded-circle" [fallback]="'fetch-avatar?userId=' + id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ id }}-avatar.png" />
                          </div>
                        </li>

                        <li *ngIf="userCount > 0" class="list-inline-item ml-n3 mr-0">
                          <a class="btn btn-sm btn-icon btn-light rounded-circle" type="button" (click)="showVisitors = !showVisitors">
                            <span class="btn-icon__inner">{{ userCount }}</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col chat-sidebar pt-1">
                <div class="input-group hide-when-small" [ngClass]="{ 'chat-collapsed': !chatCollapsed }">
                  <input type="text" class="form-control" (click)="openChat(child)" [(ngModel)]="child.chatMessage" (keyup.enter)="child.sendMessage()" placeholder="Type a message..." aria-label="" aria-describedby="button-addon2" />
                  <div class="input-group-append">
                    <button class="btn btn-white" type="button" id="button-addon2">😄</button>
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <div class="popover-window col" [ngClass]="{ 'd-none': !showVisitors }">
            <lobby-people [lobby]="lobby" (usersUpdated)="usersUpdated($event)" [connection]="connection" (closed)="showVisitors = false"></lobby-people>
          </div>
          <div class="col chat-sidebar pt-1" [ngClass]="{ 'chat-collapsed': chatCollapsed, 'hide-chat-tab': !showChat }">
            <bxl-lobby-chat #child [lobby]="lobby" (resized)="chatResized($event)" (collapse)="collapseChat()" [connection]="connection"></bxl-lobby-chat>
          </div>
        </div>
      </div>
    </main>
  </div>
</ng-container>
